import { useMutation } from '@tanstack/react-query';
import { memo, useCallback, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../../auth/AuthContext';
import ArticleGlobal from '../../components/global/ArticleGlobal';

const LoginForm = memo(({ onSubmit, isLoading }) => {
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');

	const handleEmailChange = useCallback((e) => {
		setEmail(e.target.value);
	}, []);

	const handlePasswordChange = useCallback((e) => {
		setPassword(e.target.value);
	}, []);

	const handleSubmit = useCallback((e) => {
		e.preventDefault();
		onSubmit({ email, password });
	}, [email, password, onSubmit]);

	return (
		<Form onSubmit={handleSubmit}>
			<Form.Group className="mb-2" controlId="formEmail">
				<Form.Label>Email</Form.Label>
				<Form.Control
					type="email"
					value={email}
					onChange={handleEmailChange}
					required
				/>
			</Form.Group>

			<Form.Group className="mb-2" controlId="formPassword">
				<Form.Label>Password</Form.Label>
				<Form.Control
					type="password"
					value={password}
					onChange={handlePasswordChange}
					required
				/>
			</Form.Group>
			<div className="d-flex gap-2">
				<Button
					variant="primary"
					type="submit"
					disabled={isLoading}
				>
					Log in
				</Button>
			</div>
		</Form>
	);
});

export default function LoginPage() {
	const auth = useAuth();
	const nav = useNavigate();

	const mutation = useMutation({
		mutationFn: ({ email, password }) => auth.login(email, password),
		onSuccess: (data) => {
			toast.success('Login success', { message: "welcome!" });
			const group = (data?.user?.person?.group || '').toLowerCase()
			if (group === 'administrator' || group === 'project manager' || group === 'project-manager') {
				nav('/dashboard')
			} else {
				nav('/vendor')
			}
		},
		onError: (error) => {
			toast.error(error.response?.data?.error || error.message || 'Login failed');
		}
	});

	const handleSubmit = useCallback(({ email, password }) => {
		mutation.mutate({ email, password });
	}, [mutation]);

	return (
		<div className='x-auto'>
			<ArticleGlobal className="max-w-440">
				<LoginForm onSubmit={handleSubmit} isLoading={mutation.isPending} />
			</ArticleGlobal>
		</div>
	);
}